// extracted by mini-css-extract-plugin
module.exports = {"list":"ChannelsIconList_list__3PqrH","trigger":"ChannelsIconList_trigger__1X54V","label":"ChannelsIconList_label__1G9v2","popup":"ChannelsIconList_popup__2vpQt"};